<template>
  <div v-if="TelaLogin">
    <Login />
  </div>

  <div v-else>
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Login from "./views/Login.vue";

export default {
  components: {
    Login,
    Navbar,
    Footer,
  },
  computed: {
    TelaLogin() {
      return this.$route.name === "Login";
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

:root {
  --white: #ffffff;
  --bgColor: #f8f8f8;
  --colorPrimary: #09b44d;
  --colorFilterButton: #eaeaea;

  --colorText-default: #7b7b7b;
  --colorText-secondary: #97a7c3;

  --notifyDelay: #ff7777;
  --notifyAmount: #586fff;

  --focusConfig: #09b44d85;

  --unityMatriz: #09b44d;
  --unityFilial: #ffa217;
  --unityCd: #1492e6;
  --unityJaguarao: #ff7777;

  --confirmColor: #1492e6;

  --gradienteLinear: linear-gradient(180deg,
      var(--colorPrimary) 0%,
      var(--unityFilial) 74%);
}

/* ::selection {
    background: none;
    color: none;
  }  */

body {
  background: var(--bgColor);
  color: var(--colorText-default);
  font-family: sans-serif;
}

a {
  text-decoration: none;

  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.limitW {
  max-width: 500px;
  width: 100%;
}

.containerAba {
  width: 100%;
  height: 85vh;
  position: relative;
  top: 4rem;
  display: flex;
  justify-content: center;
}

.container {
  padding: 0 1rem !important;
}

.popUp {
  background: #020e484d;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
}

.image_popUp {
  width: 40rem;
  height: 30rem;
  min-width: 200px;
  background: var(--white);
}

.image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.image_popUp img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}



@media only screen and (max-width: 600px) {
  .container {
    padding: 0 .5rem !important;
  }

  .container_link {
    height: 69vh !important;
  }

  .image_popUp {
    width: 90%;
    height: 50%;
  }

  .titleFilter {
    font-size: 2.5vw;
    padding: 0.5rem 0 !important;
  }

  .total h1,
  .total h3 {
    font-weight: bold !important;
    font-size: 3.3vh;
    padding: 10px;
  }

  .containerAba {
    top: 3rem;
  }

  .number {
    display: flex;
    align-items: center;
  }

  .number h1 {
    font-size: 1.3rem;
  }

  .image_cliente {
    width: 4rem !important;
    min-width: 4rem !important;
    min-height: 2.5rem !important;
    height: 2.5rem !important;
  }

  .title_container h2 {
    font-weight: bold !important;
    font-size: 1rem;
  }

  .rows-cliente .inform {
    flex-direction: column;
  }

  .rows-cliente .inform .title-cliente {
    margin: 0;
    font-size: 0.7rem;
  }
}</style>
